// noinspection JSUnusedGlobalSymbols
import ShowOnExtension from "./exports/ShowOnExtension.js";

const showOnExtensionInterface = ShowOnExtension.init();
const HiveInterface = window.Hive || {};
HiveInterface.showOnExtension = showOnExtensionInterface;
window.Hive = HiveInterface;
